import FacebookIcon from "@components/icons/facebook-icon";
import InstagramIcon from "@components/icons/instagram-icon";
import LinkedinIcon from "@components/icons/linkedin-icon";

export const SocialIcons = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
};
